var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imageCell"},[(_vm.text)?_c('a-avatar',{attrs:{"shape":"square","size":_vm.small,"src":'https://www.tribaliste.com/' +
        _vm.text +
        '-home_default/azilal-toile-printaniere.jpg'},on:{"click":function($event){return _vm.showModal(
        'https://www.tribaliste.com/' +
          _vm.text +
          '-home_default/azilal-toile-printaniere.jpg'
      )}}}):_c('a-avatar',{attrs:{"shape":"square","size":_vm.small}},[_c('a-icon',{attrs:{"slot":"icon","type":"loading"},slot:"icon"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }